<div class="container">
  <div class="card">
    <div class="px-6 py-4 border-b text-center header-title">
      <h2 class="title m-0">{{"COMPOSE_DIET.NEW_DIET" | translate}} {{item.userEmail}}</h2>
    </div>
  </div>
  <div *ngIf="!userInfoAccordion">
    <div class="accordion-user-info">
      <span>info {{"SUB_TABLE.USER" | translate}}</span>
      <span (click)="userInfoAccordion = true">
        <mat-icon svgIcon="mat:arrow_drop_down"></mat-icon>
      </span>
    </div>
  </div>
  <div *ngIf="userInfoAccordion" class="p-2">
    <div class="accordion-user-info">
      <span>info {{"SUB_TABLE.USER" | translate}}</span>
      <span (click)="userInfoAccordion = false">
        <mat-icon svgIcon="mat:arrow_drop_up"></mat-icon>
      </span>
    </div>
    <div *ngIf="item.survey.surveyType == 'questionario'">
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.AGE" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.age" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".HEIGHT" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.height" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".WEIGHT" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.weight" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".WAIST" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.weistline" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".FLANKS" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.hip" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".THIGH_DX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.rightThigh" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".THIGH_SX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.leftThigh" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".ARM_DX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.rightArm" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".ARM_SX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.leftArm" type="number" readonly>
        </mat-form-field>
      </div>

      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.JOB" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.activity" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.LIFE" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.lifeStyle" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6"
        *ngIf="item.survey.periodFrequency != '' && item.survey.period != ''">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.CYCLE" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.period" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.CYCLE_FREQ" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.periodFrequency" readonly>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.survey.pathologies != ''">
          <mat-label>{{"USER-NUTRITION.SURVEY_C.PATOLOGY" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.pathologies" readonly>
        </mat-form-field>
      </div>
      <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.survey.therapy != ''">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.TERAPY" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.therapy" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.survey.allergies != ''">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.ALLERGY" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.allergies" readonly>
      </mat-form-field>

      <mat-form-field appearance="fill" class="flex-auto w-100">
        <mat-label>Note</mat-label>
        <textarea cols="30" rows="4" matInput [(ngModel)]="item.survey.consideration" readonly=""></textarea>
      </mat-form-field>

      <div class="foods">
        <div class="food w-50">
          <h2>{{"USER-NUTRITION.SURVEY_C.FOOD_LOVE2" | translate}}</h2>
          <mat-chip-list *ngFor="let food of item.survey.belovedFood">
            <mat-chip class="chip">
              {{food}}
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="food w-50">
          <h2>{{"USER-NUTRITION.SURVEY_C.FOOD_HATE2" | translate}}</h2>
          <mat-chip-list *ngFor="let food of item.survey.hatedFood">
            <mat-chip class="chip">
              {{food}}
            </mat-chip>
          </mat-chip-list>
        </div>

      </div>
    </div>

    <div *ngIf="item.survey.surveyType == 'follow-up'">
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".WEIGHT" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.weight" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".WAIST" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.weistline" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".FLANKS" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.hip" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".THIGH_DX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.rightThigh" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".THIGH_SX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.leftThigh" readonly>
        </mat-form-field>
      </div>
      <div class="flex flex-col sm:flex-row gap-2 sm:gap-6">
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".ARM_DX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.rightArm" readonly>
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-auto">
          <mat-label>{{"USER-NUTRITION.SURVEY_C."+item.survey.unitSystem+".ARM_SX" | translate}}</mat-label>
          <input matInput [(ngModel)]="item.survey.leftArm" readonly>
        </mat-form-field>
      </div>

      <mat-form-field appearance="fill" class="flex-auto w-100">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.LIKE" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.like" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill" class="flex-auto w-100">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.DISLIKE" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.dislike" readonly>
      </mat-form-field>


      <mat-form-field appearance="fill" class="flex-auto w-100">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.NEW_FOOD" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.would" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.firstQuestionnaire.pathologies !== ''">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.PATOLOGY" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.firstQuestionnaire.pathologies" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.firstQuestionnaire.therapy !== ''">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.TERAPY" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.firstQuestionnaire.therapy" readonly>
      </mat-form-field>
      <mat-form-field appearance="fill" class="flex-auto w-100" *ngIf="item.firstQuestionnaire.allergies !== ''">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.ALLERGY" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.firstQuestionnaire.allergies" readonly>
      </mat-form-field>

      <mat-form-field appearance="fill" class="flex-auto w-100">
        <mat-label>{{"USER-NUTRITION.SURVEY_C.CONSIDERATION" | translate}}</mat-label>
        <input matInput [(ngModel)]="item.survey.consideration" readonly>
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="m-4"></mat-divider>

  <div class="p-2 inputs-container">
    <div class="flex-row">
      <!-- Bmi -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.BMI" | translate}}</mat-label>
        <input type="number" matInput [(ngModel)]="nutrition.bmi" />
      </mat-form-field>

      <!-- Daily Kcal -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.DAILY_KCAL" | translate}}</mat-label>
        <input type="number" matInput [(ngModel)]="nutrition.dailyKcal" />
      </mat-form-field>

      <!-- Physical activity level -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.PHYSICAL_ACTIVITY_LEVEL" | translate}}</mat-label>
        <input type="number" matInput [(ngModel)]="nutrition.physicalActivityLevel" />
      </mat-form-field>

      <!-- MB -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.MB" | translate}}</mat-label>
        <input type="number" matInput [(ngModel)]="nutrition.mb" />
      </mat-form-field>
    </div>

    <div class="flex-row">
      <!-- Energy requirement -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.ENERGY_REQUIREMENT" | translate}}</mat-label>
        <input type="number" matInput [(ngModel)]="nutrition.energyRequirement" />
      </mat-form-field>

      <!-- Carbohydrates -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.CARBOHYDRATES" | translate}}</mat-label>
        <input matInput [(ngModel)]="nutrition.carbohydrates" />
      </mat-form-field>

      <!-- Fats -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.FATS" | translate}}</mat-label>
        <input matInput [(ngModel)]="nutrition.fats" />
      </mat-form-field>

      <!-- Protein -->
      <mat-form-field class="flex-item">
        <mat-label>{{"COMPOSE_DIET.PROTEIN" | translate}}</mat-label>
        <input matInput [(ngModel)]="nutrition.protein" />
      </mat-form-field>

    </div>

    <div>
      <mat-form-field class="w-100">
        <mat-label>Note</mat-label>
        <textarea matInput [(ngModel)]="nutrition.note" rows="3"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="recipes-container">
    <div class="filter-zone">
      <div class="rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
        <input [formControl]="searchCtrl" class="px-4 py-2 border-0 outline-none w-full"
          placeholder="{{'GLOBAL.SEARCH' | translate}}" type="search" (keyup.enter)="search(true)" />
      </div>
      <div class="flex gap-4 mt-4">

        <!-- Filtro Prezzo -->
        <mat-form-field appearance="fill">
          <mat-label>{{"COMPOSE_DIET.TAGS" | translate}}</mat-label>
          <mat-select [(ngModel)]="filter.selectedTags">
            <mat-option [value]="''"></mat-option>
            <mat-option *ngFor="let tag of availableTags" [value]="tag">
              {{ tag }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <button class="ml-4 flex-none" color="primary" mat-mini-fab type="button" (click)="search(true)">
        <mat-icon svgIcon="mat:search"></mat-icon>
      </button>
    </div>

    <div class="recipe-results">
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-6">
        <div *ngFor="let recipe of recipes" class="card" (click)="selectedRecipe = recipe"
          (dblclick)="addSelectedRecipeTo(recipeKeys[currentStep])">
          <div class="border p-4 rounded-lg"
            [class.selected-recipe]="selectedRecipe && selectedRecipe._id === recipe._id" style="height: 100%;">
            <img *ngIf="recipe.imageUrl" [src]="recipe.imageUrl"
              class="w-full h-32 object-cover rounded-lg mb-4" />
            <h2>{{recipe.i18nTitle[translate.currentLang.toUpperCase()]}}</h2>
            <p class="truncate" [innerHTML]="recipe.i18nPreparation[translate.currentLang.toUpperCase()]"></p>
            <div class="chip-container">
              <div *ngFor="let tag of recipe.tags" class="chip">
                {{ tag }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <mat-paginator *ngIf="recipes" [length]="lunghezza" [pageSize]="pageSize" (page)="onPageChanged($event)">
      </mat-paginator>
    </div>


    <div class="horizontal-stepper">
      <div class="step-header">
        <button (click)="prevStep()" [disabled]="currentStep === 0">
          {{"COMPOSE_DIET.BACK" | translate}}
        </button>

        <div class="step-title">
          <h2>
            {{ recipeKeys[currentStep] | titlecase }}
            <span *ngIf="currentStep === 4">{{'Componi piatto' | titlecase}}</span>
            <!-- <mat-icon svgIcon="mat:add" class="icon-lg" *ngIf="currentStep < 4"
              (click)="addSelectedRecipeTo(recipeKeys[currentStep])"></mat-icon> -->
          </h2>
          <div class="step-count">
            <span>Step {{ currentStep + 1 }} / {{ recipeKeys.length+1 }}</span>
            <!-- METTO +1 alla length perche ho un quarto step che non è dentro recipeKeys-->
            <span (click)="openSummary()" class="ml-2">
              <mat-icon svgIcon="mat:info"></mat-icon>
            </span>
          </div>
        </div>
        <button (click)="nextStep()" [disabled]="currentStep === 4">
          {{"COMPOSE_DIET.NEXT" | translate}}
        </button>
      </div>

      <div class="step-content" *ngIf="recipeKeys.length && currentStep < 4">
        <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 mt-6">
          <div *ngFor="let item of recipeToSend[recipeKeys[currentStep]]; let i = index" class="card"
            [ngClass]="{ 'col-span-full': expandedCardId === (item._id+'_'+i) }">
            <div class="border p-4 rounded-lg flex flex-col h-full bg-white transition-all duration-300">
              <p>Giorno {{(i+1)}}</p>
              <img [src]="environmentNode + '/get-recipe-image/' + item._id"
                class="w-full h-32 object-cover rounded-lg mb-4" />

              <h3 class="text-center text-sm font-semibold mb-4"
                *ngIf="!editingRecipeInfo ||editingRecipeInfo &&  expandedCardId !== (item._id+'_'+i)">
                {{ item.i18nTitle[translate.currentLang.toUpperCase()] }}
                <span (click)="editRecipeInfo()" *ngIf="expandedCardId === (item._id+'_'+i)">
                  <mat-icon svgIcon="mat:edit"></mat-icon>
                </span>
              </h3>
              <div class="edit-ingredient-grid mb-4" *ngIf="editingRecipeInfo && expandedCardId === (item._id+'_'+i)">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{"GLOBAL.ITA" | translate}}
                  </mat-label>
                  <input matInput [(ngModel)]="item.i18nTitle['IT']" required />
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{"GLOBAL.ENG" | translate}}
                  </mat-label>
                  <input matInput [(ngModel)]="item.i18nTitle['EN']" required />
                </mat-form-field>
                <span (click)="saveRecipeInfo()">
                  <mat-icon svgIcon="mat:save"></mat-icon>
                </span>
                <div>
                  <h2 class="title mb-2">{{"NEW-SUB.DESC" | translate}} {{"GLOBAL.ITA" | translate}}</h2>
                  <quill-editor [(ngModel)]="item.i18nPreparation['IT']" [styles]="{ flex: '1 1 auto' }"></quill-editor>
                  <h2 class="title mb-2 mt-2">{{"NEW-SUB.DESC" | translate}} {{"GLOBAL.ENG" | translate}}</h2>
                  <quill-editor [(ngModel)]="item.i18nPreparation['EN']" [styles]="{ flex: '1 1 auto' }"></quill-editor>
                </div>
              </div>

              <div *ngIf="expandedCardId === (item._id+'_'+i)" class="mb-4">
                <div *ngIf="!editingRecipeInfo" [innerHTML]="item.i18nPreparation[translate.currentLang.toUpperCase()]">
                </div>

                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 gap-4 mt-6">
                  <div *ngFor="let ingredient of item.ingredients" class="flex flex-col"
                    [ngClass]="{ 'col-span-full': expandedIngredientId === ingredient }">
                    <mat-form-field appearance="fill" class="w-full" *ngIf="expandedIngredientId !== ingredient">
                      <span matPrefix (click)="editRecipeIngredient(ingredient)">
                        <mat-icon svgIcon="mat:edit" class="prefix-edit"></mat-icon>
                      </span>
                      <mat-label>
                        {{ item.ingredientsFull[ingredient].i18nName[translate.currentLang] }}
                      </mat-label>
                      <input matInput [(ngModel)]="item.ingredientsFull[ingredient].quantity"
                        [required]="item.ingredientsFull[ingredient].unit['it'] ==='q.b.' ? false : true" />
                      <span matSuffix>
                        {{ item.ingredientsFull[ingredient].unit[translate.currentLang] }}
                      </span>
                    </mat-form-field>
                    <div *ngIf="expandedIngredientId === ingredient" class="edit-ingredient-grid">
                      <mat-form-field appearance="fill">
                        <mat-label>
                          {{"GLOBAL.ITA" | translate}}
                        </mat-label>
                        <input matInput [(ngModel)]="item.ingredientsFull[ingredient].i18nName.it" required />
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>
                          {{"RECIPES_LIST.UNIT" | translate}} {{"GLOBAL.ITA" | translate}}
                        </mat-label>
                        <input matInput [(ngModel)]="item.ingredientsFull[ingredient].unit.it" required />
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>
                          {{"GLOBAL.ENG" | translate}}
                        </mat-label>
                        <input matInput [(ngModel)]="item.ingredientsFull[ingredient].i18nName.en" required />
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>
                          {{"RECIPES_LIST.UNIT" | translate}} {{"GLOBAL.ENG" | translate}}
                        </mat-label>
                        <input matInput [(ngModel)]="item.ingredientsFull[ingredient].unit.en" required />
                      </mat-form-field>
                      <span (click)="saveRecipeIngredient()">
                        <mat-icon svgIcon="mat:save"></mat-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-auto flex justify-center space-x-4">
                <mat-icon svgIcon="mat:delete" (click)="deleteRecipe(item)"></mat-icon>
                <mat-icon svgIcon="mat:edit" (click)="onEdit(item, i)"></mat-icon>
                <mat-icon svgIcon="mat:check_circle" style="color: green"
                  *ngIf="areSingleMealCompleted(item.ingredientsFull)"></mat-icon>
                <mat-icon svgIcon="mat:zoom_in_map" *ngIf="expandedCardId === (item._id+'_'+i)"
                  (click)="reduceExpand()"></mat-icon>
                <mat-icon svgIcon="mat:content_copy" (click)="duplicateRecipe(item)"></mat-icon>
              </div>
              <div class="flex mt-2 justify-center space-x-4">
                <mat-icon svgIcon="mat:arrow_circle_left" [class.arrow-disabled]="i === 0"
                  (click)="moveLeft(i)"></mat-icon>
                <mat-icon svgIcon="mat:arrow_circle_right"
                  [class.arrow-disabled]="i === (recipeToSend[recipeKeys[currentStep]].length-1)"
                  (click)="moveRight(i)"></mat-icon>
              </div>
            </div>
          </div>
          <div class="card" *ngFor="let item of getEmptySpace(recipeToSend[recipeKeys[currentStep]].length)"
            style="height: auto; min-height: 234px;">

          </div>
        </div>

      </div>
      <div class="step-content" *ngIf="currentStep === 4">
        <div style="display: flex; justify-content: center;">
          <mat-form-field appearance="fill">
            <mat-label>{{"COMPOSE_DIET.CALORIES" | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedPrecompiledCalories" (ngModelChange)="onCaloriesChange()">
              <mat-option *ngFor="let opt of precompiledOptions" [value]="opt.key">
                {{ opt.description }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngFor="let category of mealCategories">
          <h3><span class="meal-type">{{category.mealType}}</span> - {{
            category.i18nCategory[translate.currentLang.toUpperCase()] }}</h3>

          <div class="food-items-wrapper grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            <div *ngFor="let food of category.foods">
              <mat-form-field appearance="fill" [matTooltip]="food.i18nName[translate.currentLang.toUpperCase()]"
                matTooltipPosition="above">
                <mat-label>{{ food.i18nName[translate.currentLang.toUpperCase()] }}</mat-label>
                <input matInput required [(ngModel)]="food.value"
                  [name]="food.i18nName[translate.currentLang.toUpperCase()]" />
                <span matSuffix>{{ food.unit }}</span>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottoni">
      <button (click)="confirmClose()" mat-button-base class="m-4">{{"GLOBAL.CLOSE" | translate}}</button>
      <span *ngIf="!item.survey.diet || item.survey.diet && dietStatus !== 'send'">
        <button [disabled]="isAutosaving" mat-raised-button class="m-4 bottone-viola" (click)="send()"
          *ngIf="areAllMealsComplete() && areAllFoodsFilled() && areAllNutritionalValuesFilled()">
          {{(isAutosaving ? "GLOBAL.AUTOSAVE" : "COMPOSE_DIET.SUBMIT") | translate}}</button>
        <button [disabled]="isAutosaving" mat-raised-button class="m-4 bottone-viola" (click)="send()"
          *ngIf="!areAllMealsComplete() || !areAllFoodsFilled() || !areAllNutritionalValuesFilled()">
          {{(isAutosaving ? "GLOBAL.AUTOSAVE" : "COMPOSE_DIET.SAVE_AS_DRAFT")| translate}}</button>
      </span>
      <span *ngIf="item.survey.diet && dietStatus === 'send'">
        <button [disabled]="!areAllMealsComplete() || !areAllFoodsFilled() || !areAllNutritionalValuesFilled()" mat-raised-button class="m-4 bottone-viola" (click)="edit()">
          {{"GLOBAL.EDIT" | translate}}</button>
      </span>
    </div>
  </div>
